module.exports = __webpack_public_path__ + "public/images/partners/partner-3.edc314e668e2227156fcbc7838d77059.png";